import http from './http';

export async function postPaged(url, { page = 1, limit = 10, search = '', fillterDate= [] } = {}) {
  try {
    const date = Array.isArray(fillterDate) ? fillterDate : (Array.isArray(fillterDate) ? fillterDate : []);
    const res = await http.post(url, { page, limit, search, date });
    const data = res?.data ?? {};

    // Nếu data.items không tồn tại, fallback về []
    const items = Array.isArray(data.items) ? data.items : (Array.isArray(data) ? data : []);
    const total = typeof data.total === 'number' ? data.total : items.length;

    return {
      items,
      total,
      page: data.page || page,
      limit: data.limit || limit,
      total_pages: data.total_pages || Math.ceil(total / limit),
    };
  } catch (err) {
    console.error('[postPaged] Lỗi khi gọi API:', err?.response?.data || err.message);
    // fallback để không crash component
    return { items: [], total: 0, page, limit, total_pages: 0 };
  }
}
